<template>
  <div class="homepage">
    <div v-show=false class="loginButton">
      <LoginButton />
    </div>
    <div class="introduction">
      <div class="introduction-title">八局AI智能体中心</div>
      <div class="introduction-subtitle">建模助手、投标助手、BIM审查、BIM政策、BIM渲染...</div>
    </div>
    <div class="text-input">
      <img src="../../assets/images/inputIcon.png" alt="Image" class="input-image" />
      <input type="text" class="input-field" placeholder="Hi!问一下Revit如何创建墙体?" v-model="message" @keydown="handleKeydown"/>
      <button class="send-button" @click="switchChatpage"></button>
    </div>
    <div class="block">
      <el-carousel 
        height="500px"
        :style="carouselStyle"
        trigger="click"
        indicator-position="outside"
        :autoplay="true"
        >
        <el-carousel-item v-for="(item, index) in imageSrc" :key="index">
            <img :src="item" :alt="index" class="projectPic" >
        </el-carousel-item>
      </el-carousel>
  </div>

  </div>
</template>


<script>
import LoginButton from '../components/LoginButton.vue'

export default {
  name: 'HomePage',
  components: {
    LoginButton,
  },
  data() {
    return {
      imageSrc: [require('../../assets/images/slice1.png'),
      require('../../assets/images/slice2.png'),
        ],
      showLogin: false,
      message: ''
      }
    },
  computed: {
    carouselStyle() {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        return 'width: 100%; border-radius: 5px; height: 200px;';
      }
      return 'width: 1230px; border-radius: 5px;';
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 强制重新计算响应式样式
      this.$forceUpdate();
    },
    handleKeydown(e) {
      if (e.key === 'Enter') {
        this.switchChatpage();
      }
    },
    switchChatpage() {
      if(this.$store.state.loginStatus == false) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        return;
      }
      this.$router.push({ path: '/chat', query: { message: this.message } });
    }
  }
}
</script>

<style scoped>
.topbar {
  position: absolute;
  left: 50%;
  top: 27px;
  transform: translate(-50%, 0);
  align-items: center;
  align-content: center;
  width: 685px;
  height: 27px;
}
.loginButton {
  position: absolute;
  left: 1714px;
  top: 17px;
}
.projectPic {
  object-fit: contain;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.homepage {
  position:fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('../../assets/images/background.png') no-repeat;
  width: 100%;
  height: 100vh;
  
}
.introduction{
    display: flex;
    margin-top:100px;
    flex-direction: column;
    align-items: center;
    font-family: PingFang SC;
    color: #ffffff;
  .introduction-title{
    
    font-size: 99px;
  }
  .introduction-subtitle{
    font-size: 46px;
  }
}
.text-input{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  margin-bottom:30px;
  background: rgb(16,16,16,1);
  height: 82px;
  width: 590px;
  border-radius: 16px;
  .input-field{
    outline: none;
    width:570px;
    height: 42px;
    background: rgb(16,16,16,1);
    font-size:26px ;
    color: #ffffff;
    border: 0;
  }
  
  .input-image{
    width: 47px;
    height: 47px;
    margin-right:10px;
    margin-left: 10px;
    animation: rotateAnimation 1s linear infinite; /* 添加动画属性 */
    
  }
  @-webkit-keyframes rotateAnimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  

  .send-button {
  background: url('../../assets/images/sendMessage.png') no-repeat;
  background-size: contain;
  
  width: 32px;
  height: 32px;
  border: 0;
  margin-right:10px;
  margin-left: 10px;
  cursor: pointer;
  }
  .send-button:hover{
    width: 35px;
    height: 35px;
  }
  .block{
    display: absolute;
    width:1230px;
    height: 625px;
  }
  .el-carousel__item{
    display: absolute;
    margin-left: 10px;
    margin-right: 10px;
    width: 324.5px;
  }
}

/* 手机端响应式样式 */
@media (max-width: 768px) {
  .homepage {
    padding-top: 60px;
    background-size: cover;
    background-position: center;
  }
  
  .homepage .introduction {
    margin-top: 100px;
  }
  
  .homepage .introduction .introduction-title {
    font-size: 60px;
    text-align: center;
    padding: 0 15px;
    line-height: 1.2;
  }
  
  .homepage .introduction .introduction-subtitle {
    font-size: 30px;
    text-align: center;
    padding: 0 15px;
    line-height: 1.4;
    margin-top: 8px;
  }
  
  .homepage .text-input {
    width: 85%;
    max-width: 320px;
    height: 45px;
    margin: 15px auto;
    padding: 0 8px;
    display: flex;
    align-items: center;
  }
  
  .homepage .text-input .input-field {
    flex: 1;
    font-size: 15px;
    height: 25px;
    padding: 0 5px;
    min-width: 0;
  }
  
  .homepage .text-input .input-image {
    width: 22px;
    height: 22px;
    margin-right: 6px;
    flex-shrink: 0;
  }
  
  .homepage .text-input .send-button {
    width: 22px;
    height: 22px;
    margin-left: 6px;
    flex-shrink: 0;
  }
  
  .homepage .text-input .send-button:hover {
    width: 20px;
    height: 20px;
  }
  
  .homepage .block{
    display: absolute;
    width: 90%;
    max-width: 350px;
    height: 100%;
  }
  
  .homepage .block .el-carousel {
    width: 100% !important;
    height: 100% !important;
  }
  
  .homepage .block .el-carousel__item {
    width: 100%;
    margin: 0;
  }
  
  .homepage .projectPic {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>